// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","EventsWrapper":"EventsWrapper-5dpm7w521vjqaxy8km2vyb1hnaketw8pj798j687m28gcrkf1qtqpv9wwtx4bund7w245evyy7kvw6v7xa5a1kdw2mfcmtvxb743qy","loading":"loading-4puc4ddmwhpxd9c5z4b7xqt9n3y25h63xnaz6qpw7xg11rpkz1ngx31seubsdge9cfjtuakmtc7d6m7m192287z96gpmmnywhrku86g","pulse":"pulse-9ptvjfegw1mu2xxyc2wrqhjadzszyapemf1kbqzksg6mrezbwgfh9zyz9rxkgsgv84bjpxfn4n47rg4k3873wn1abztmvf6e5hccwg"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PlannedEvents/PlannedEvents.module.scss
// module id = 1727
// module chunks = 0